// This component is for client

import { Fragment, useEffect } from "react";
import { Popover, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { ChartPieIcon, DocumentTextIcon } from "@heroicons/react/24/outline";
import { API } from "../../service/api";
import { showErrorToast } from "../../utils/toast";
import { useNCallContext } from "../../context/ncall-context";
import { useNavigate } from "react-router-dom";

export default function ReportList() {
  const { state, dispatch, getReports } = useNCallContext();

  const navigate = useNavigate();
  const { reports } = state;

  const viewHandler = async (report) => {
    let data = {};

    try {
      const _report = await API.getReport(report.id, {
        report_url: report.report_url,
        report_source: report.report_source,
      });
      //console.log(_report);
      //   if (report.report_source === "calls") {
      data["rows"] = _report?.data;
      data["columns"] = JSON.parse(report.output_feilds);
      data["info"] = {
        heading: report.report_heading,
        name: report.report_name,
        subheading: report.report_subheading,
        footer: report.report_footer,
      };
      data["sortBy"] = report.sortBy;
      data["orderBy"] = report.orderBy;
      //   }

      navigate("/client/view-report", {
        state: { data },
      });
    } catch (error) {
      showErrorToast(error);
    }

    //console.log(report);
  };

  useEffect(() => {
    getReports();

    //console.log(reports);
  }, []);

  return (
    <Popover className="relative">
      <Popover.Button className=" w-full group flex justify-between items-center px-2 py-2 text-sm font-medium rounded-md text-white hover:bg-indigo-600 hover:bg-opacity-75">
        <div className="flex  items-center gap-2">
          <ChartPieIcon className="h-5 w-5 mr-3 " aria-hidden="true" />
          <span>Reports</span>
        </div>
        <ChevronDownIcon className="h-5 w-5" aria-hidden="true" />
      </Popover.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <Popover.Panel className=" z-10 mt-2 flex w-full">
          <div className="w-screen max-w-md flex-auto overflow-hidden rounded-sm   bg-indigo-600 text-sm leading-6 shadow-lg ring-1">
            {reports.length === 0 ? (
              <span className="p-2 py-4">No Reports Available</span>
            ) : (
              <div className="overflow-auto ">
                {reports.map((item) => (
                  <div
                    onClick={() => viewHandler(item)}
                    key={item.id}
                    className="group relative flex gap-x-2  p-2  m-1 bg-indigo-700 cursor-pointer"
                  >
                    <div className="flex flex-none items-center justify-center">
                      <DocumentTextIcon className="h-4 w-4 text-white" />
                    </div>
                    <div className="w-full overflow-hidden">
                      <p className="text-white  truncate">{item.report_name}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </Popover.Panel>
      </Transition>
    </Popover>
  );
}
